import React, { useState } from 'react'
import './modal.css'

export default function TryModal({ showModal, setShowModal }) {
    return (
        <div id="myModal" style={{ display: showModal ? 'block' : 'none' }} className="modal">
            <div className="modal-content">
                <h1 className='form-title'>Formulaire de demo</h1>

                <div className="input-area">
                    <label htmlFor="entreprise">Nom: </label>
                    <input type="text" className='form-element' name="nom" placeholder="Nom" />
                </div>

                <div className="input-area">
                    <label htmlFor="email">Prenom: </label>
                    <input type="text" className='form-element' name="prenom" placeholder="Prenom" />
                </div>

                <div className="input-area">
                    <label htmlFor="email">Adresse: </label>
                    <input type="text" className='form-element' name="adresse" placeholder="Adresse" />
                </div>

                <div className="input-area">
                    <label htmlFor="email">Entreprise: </label>
                    <input type="text" className='form-element' name="entreprise" placeholder="Entreprise" />
                </div>

                <div className="input-area">
                    <label htmlFor="email">Fonction: </label>
                    <input type="text" className='form-element' name="function" placeholder="Fonction" />
                </div>

                <div className="input-area">
                    <label htmlFor="email">Motif de demande: </label>
                    <input type="text" className='form-element' name="motif" placeholder="Motif de demande" />
                </div>

                <div className="input-area">
                    <label htmlFor="email">Date de la demo: </label>
                    <input type="date" className='form-element' name="date" placeholder="Date" />
                </div>

                <div className="form-button-container">
                    <div 
                        onClick={() => setShowModal(false)}
                        style={{backgroundColor: '#ed3939cc'}} 
                        className="landing-tarif__pack-item-btn">
                            Annuler
                    </div>

                    <div 
                        onClick={() => setShowModal(false)}
                        className="landing-tarif__pack-item-btn">
                            Valider
                    </div>
                </div>
            </div>
        </div>
    )
}

